<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { deductCredits } from "../firebaseOperations";
  import { userData, userSignedIn } from "../store";
  import { trackButtonClick } from "../utils";

  export let inputText: string;
  const deob = process.env.DEOBFUSCATE;
  const dispatch = createEventDispatcher();
  let isLoading = false;
  let isSuccessful = false;
  let overlayText = "Please sign in!";

  async function handleClick() {
    if (!$userSignedIn) {
      return;
    }
    const deobButton = document.getElementById("deobfuscate");
    deobButton.innerHTML = ""; // Clear the existing content

    // Create loading text
    const loadingText = document.createElement("div");
    loadingText.setAttribute("class", "loading-text");
    loadingText.innerText = "Loading...";
    deobButton.appendChild(loadingText);
    let result = 0;
    if (!$userData.admin || !$userData.premium) {
      result = await deductCredits($userData.id, 1);
      if (result === 0) {
        $userData.credits -= 1;
      } else {
        if (result == 1) {
          overlayText = "Insufficient Credits";
          document.getElementById("deobfuscate").classList.add("grey-overlay");
        } else if (result == 2) {
          overlayText = "User does not exist!";
          document.getElementById("deobfuscate").classList.add("grey-overlay");
        } else if (result == 3) {
          overlayText = "Transaction error!";
          document.getElementById("deobfuscate").classList.add("grey-overlay");
        }
        setTimeout(() => {
          overlayText = "Cost: 1 Credit";
        }, 2000);
        deobButton.innerHTML = "Un-Cloak";
        return;
      }
    }
    await new Promise((r) => setTimeout(r, 1000));
    trackButtonClick("Deobfuscate", 1);
    deobfuscate();
  }
  async function deobfuscate() {
    isSuccessful = false;
    isLoading = true;

    const deobfuscateAsync = async () => {
      try {
        const response = await fetch(deob, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            inputs: inputText,
          }),
        });

        if (!response.ok) {
          throw new Error("Request failed");
        }

        const data = await response.json();
        const responseData = data.modifiedData;
        let mobile = false;
        try {
          await navigator.clipboard.writeText(responseData);
        } catch (error) {
          mobile = true;
        }
        if (mobile) {
          try {
            await window.Toaster.postMessage(responseData);
          } catch (error) {
            console.error(error);
          }
        }

        dispatch("success", responseData);
        document.getElementById("deobfuscate").innerHTML = "Success!";
        setTimeout(() => {
          document.getElementById("deobfuscate").innerHTML = "Un-Cloak";
        }, 2000);
      } catch (error) {
        console.error(error);
      }

      setTimeout(() => {
        isSuccessful = true;
        isLoading = false;

        setTimeout(() => {
          isSuccessful = false;
        }, 2000);
      }, 500);
    };

    setTimeout(deobfuscateAsync, 1000);
  }
  $: userSignedIn.subscribe((value) => {
    if (value) {
      overlayText = "Cost: 1 Credit";
    } else {
      overlayText = "Please sign in!";
    }
    if ($userData.premium || $userData.admin) {
      overlayText = "";
    }
  });
</script>

<div class="button-container">
  <button
    id="deobfuscate"
    on:click={handleClick}
    class:grey-overlay={!$userSignedIn}
    class="button deobfuscate-button active-button"
  >
    Un-Cloak
  </button>
  <div class="overlay-text">{overlayText}</div>
</div>
